import * as type from './types';

export function socialSignup(data) {
    return {
        type: type.POST_SOCIAL_SIGNUP_REQUESTED,
        data: data,
    }
}